<template>
  <div 
    v-loading="posterLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="dilog-box-loading">
    <div ref="poster" id="poster" class="poster">
      <!-- 背景图 -->
      <!-- <el-image
        :src="backgroundImage"
        alt="Background"
        @load="handleImageLoad" 
        @error="handleImageError"
        class="background-image"
      >
      </el-image> -->
      
      <img 
        v-if="type === 1"
        src="./../assets/xi_1.png" 
        alt="Background" 
        class="background-image"
      >
      <img 
        v-if="type === 2"
        src="./../assets/xi_2.png" 
        alt="Background" 
        class="background-image"
      >
      <img 
        v-if="type === 3"
        src="./../assets/xi_3.png" 
        alt="Background" 
        class="background-image"
      >
      <img 
        v-if="type === 4"
        src="./../assets/xi_4.png" 
        alt="Background" 
        class="background-image"
      >
      <img 
        v-if="type === 5"
        src="./../assets/xi_5.png" 
        alt="Background" 
        class="background-image"
      >

      <!-- 文字 -->
      <div class="poster-text">
        <div class="text-1">
          截至{{ formatDate(time) }}
        </div>
        <div class="text-2">
          <div>
            {{ name }}<span> 网民参与答题  总样本量</span>
          </div>
        </div>
        <div class="text-3">
          突破{{ formatNumber(totalAmount) }}<span>份</span>
        </div>
      </div>
      <div class="poster-text-center_s">
        <div><span>主问卷</span>{{ formatNumber_s(rowData.amount) }}{{formatUnit(rowData.amount)}}份</div>
        <span>&nbsp;&nbsp;&nbsp;</span>
        <div><span>专题问卷</span>{{ formatNumber_s(rowData.specialAmount) }}{{formatUnit(rowData.specialAmount)}}份</div>
      </div>
      <div class="poster-text-left">
        <div>{{ formatNumber_s(rowData.publicAmount+rowData.publicSpecialAmount) }}<span>{{formatUnit(rowData.publicAmount+rowData.publicSpecialAmount)}}份</span></div>
        <div>{{ formatNumber_s(rowData.publicAmount) }}<span>{{formatUnit(rowData.publicAmount)}}份</span></div>
        <div>{{ formatNumber_s(rowData.publicSpecialAmount) }}<span>{{formatUnit(rowData.publicSpecialAmount)}}份</span></div>
      </div>
      <div class="poster-text-right">
        <div>{{ formatNumber_s(rowData.employmentAmount + rowData.employmentSpecialAmount) }}<span>{{formatUnit(rowData.employmentAmount+rowData.employmentSpecialAmount)}}份</span></div>
        <div>{{ formatNumber_s(rowData.employmentAmount) }}<span>{{formatUnit(rowData.employmentAmount)}}份</span></div>
        <div>{{ formatNumber_s(rowData.employmentSpecialAmount) }}<span>{{formatUnit(rowData.employmentSpecialAmount)}}份</span></div>
      </div>
    </div>
    <div style="margin-top:20px;">
      <el-button
        v-if="isPc"
        type="primary"
        @click="generatePoster"
      >
        保存本地
      </el-button>
      <el-button
        v-else
        type="primary"
        @click="openImg"
      >
        保存本地
      </el-button>
    </div>
    
  </div>
</template>

<script>

import html2canvas from 'html2canvas';
export default {
  name: 'CustomButton',
  props: {
    type: {
      type: Number,
      default: 1
    },
    isPc: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: {
        publicAmount: 0,
        publicSpecialAmount: 0,
        employmentAmount: 0,
        employmentSpecialAmount: 0,
        amount: 0, // 主问卷总量
        specialAmount: 0, // 主问卷总量
      }
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: () => {} // 默认点击事件为空函数
    }
  },
  data() {
    return {
      posterLoading: false,
      // https://survey.iscn.org.cn/tduck-cloud/miniAppFile/
      imgList: [
        {
          id: 1,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/fb53f7e32c2f4165bf88261a0bc97c27.png',
          name: '橙色'
        },
        {
          id: 2,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/cc4d3679565a4518990a43d6a2724883.png',
          name: '蓝色'
        },
        {
          id: 3,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/81f9bc24ac2f45199cb55c69c130c014.png',
          name: '紫色'
        },
        {
          id: 4,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/94dc49de5b9b499fafe4c8314305095a.png',
          name: '浅蓝色'
        },
        {
          id: 5,
          img: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/53c02762d37d47d883eba744572914bf.png',
          name: '红色'
        }
      ],
      backgroundImage: './../assets/fb53f7e32c2f4165bf88261a0bc97c27.png',
    }
  },
  created() {
    console.log('rowData', this.rowData)
    // if(!!this.type) {
    //   let bgImg = this.imgList.find(item=>item.id === this.type);
    //   this.backgroundImage = bgImg.img;
    // }
  },
  methods: {
    isWechat() {
      return /micromessenger/i.test(navigator.userAgent);
    },
    // 格式化数值的方法
    formatNumber(value) {
      if(this.name === '全国' && value >= 100000) {
        return `${Math.floor(value / 100000)}0万`;
      } else if (value >= 100000) {
        return `${Math.floor(value / 10000)}万`;
      } else if (value >= 10000) {
        return parseInt(value / 1000) * 1000;
      } else if (value >= 1000) {
        return parseInt(value / 100) * 100;
      } else {
        return parseInt(value / 10) * 10;
      }
    },
    // 格式化数值的方法
    formatNumber_s(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.totalAmount >= 100000) {
        return (value / 10000).toFixed(4);
      } else {
        return value;
      }
    },
    formatUnit(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.totalAmount >= 100000) {
        return '万';
      } else {
        return '';
      }
    },
    handleImageLoad(event) {
      console.log('图片加载完成', event);
      this.posterLoading=false;
      // 执行图片加载完成后的逻辑
    },
    handleImageError(event) {
      console.log('图片加载失败', event);
      // 处理图片加载失败的逻辑
    },
    handleClick() {
      // 调用传入的点击事件处理器
      this.onClick();
    },
    openImg() {
      this.$nextTick(()=>{
        console.log('this.$refs.poster',this.$refs.poster)
        if(this.$refs.poster.id == 'poster') {
          const posterElement = this.$refs.poster;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
            scale: window.devicePixelRatio,
          }).then(canvas => {
              // 将 Canvas 转换为 Blob 对象
              canvas.toBlob((blob) => {
                // 创建一个临时链接
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${this.name}-${this.totalAmount}喜报.jpg`; // 设置下载文件的名称

                // 触发点击事件
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();

                // 释放临时链接
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              }, 'image/jpeg');
          }).catch(err => {
            this.$message.error(err);
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })
    },
    generatePoster() {
      this.$nextTick(()=>{
        if(this.$refs.poster.id == 'poster') {
          const posterElement = this.$refs.poster;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
          }).then(canvas => {
            const posterImage = canvas.toDataURL('image/jpg');
            // 在这里你可以保存或显示生成的海报图像
            // 如果要保存为文件，可以创建一个下载链接
            const link = document.createElement('a');
            link.href = posterImage;
            link.download = `${this.name}-${this.amount}喜报.jpg`;
            link.click();
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })
      
    },
    formatDate(dateString) {
      // 将日期字符串转换为Date对象
      console.log('dateString',dateString)
      const dateStr = dateString.replace(/-/g,"/");
      console.log('dateStr',dateStr)
      const date = new Date(dateStr);

      // 获取月、日、小时、分钟
      const month = date.getMonth() + 1; // getMonth() 返回的月份是从0开始的
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // 格式化月、日、小时、分钟（补零）
      const monthStr = month < 10 ? `0${month}` : `${month}`;
      const dayStr = day < 10 ? `0${day}` : `${day}`;
      const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
      const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;

      // 拼接格式化后的日期字符串
      return `${monthStr}月${dayStr}日 ${hoursStr}:${minutesStr}`;
    }
  }
};
</script>

<style scoped>
.dilog-box-loading {
  min-height: 960px;
  display:flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content:center;
}
.poster {
  position: relative;
  width: 540px;
  height: 960px;
  /* width: 100%;
  height: calc(100% * 81 / 54); */
  margin-bottom: 20px;
}
.background-image {
  width: 100%;
  height: 100%;
}

.poster-text {
  position: absolute;
  left: 50%;
  top: 36.8%;
  bottom: 46.5%;
  transform: translateX(-50%);
  color: #EE3C38;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.poster-text .text-1 {
  color: rgb(60, 60, 60);
  font-family: CustomFont6;
  letter-spacing: 1px;
  font-size: 20px;
  line-height: 46px;
  display: flex;
  align-items: center;
}
.poster-text .text-2 {
  flex: 1;
  color: #DA2618;
  font-family: CustomFont5;
  width: 100%;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.poster-text .text-2 div{
  width: 80%;
}
.poster-text .text-2 div span{
  font-size: 24px;
}
.poster-text .text-3 {
  font-family: CustomFont4;
  letter-spacing: 2px;
  font-size: 56px;
  color: #EE2C27;
}
.poster-text .text-3 span {
  font-family: CustomFont4;
  font-size: 32px;
}
.poster-text-center_s {
  position: absolute;
  top: 53.8%;
  left: 50%;
  width: 86%;
  transform: translateX(-50%);
  font-size: 15px;
  line-height: 20px;
  color: rgb(253, 140, 36);
  font-family: CustomFont4;
  display: flex;
  justify-content: center;
  /* justify-content: space-around; */
}
.poster-text-center_s span {
  margin-right: 8px;
}
.poster-text-left {
  position: absolute;
  width: 26%;
  top: 59%;
  bottom: 31%;
  left: 25%;
  font-size: 18px;
  line-height: 22px;
  color: #EE3C38;
  display: flex;
  flex-direction: column;
  justify-items: center;
  font-family: CustomFont4;
}
.poster-text-right {
  position: absolute;
  width: 26%;
  top: 59%;
  bottom: 31%;
  left: 69%;
  font-size: 18px;
  line-height: 22px;
  color: #EE3C38;
  display: flex;
  flex-direction: column;
  justify-items: center;
  font-family: CustomFont4;
}
.poster-text-left div:first-child,.poster-text-right div:first-child {
  line-height: 37px;
  font-size: 22px;
  font-weight: 600;
  color: #EE2C27;
}
.poster-text-left div:last-child,.poster-text-right div:last-child {
  font-size: 18px;
  line-height: 38px;
}
.poster-text-left span, .poster-text-right span{
  font-size: 12px;
}
.poster-text-left div:first-child span,.poster-text-right div:first-child span {
  font-size: 14px;
}
.poster-text-s {
  position: absolute;
  top: 63.5%;
  left: 50%;
  transform: translateX(-50%);
  color: #EE3C38;
  width: 86%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.poster-text-s div {
  font-family: CustomFont4;
  font-size: 36px;
}
.poster-text-s div span {
  font-size: 22px;
}
@media screen and (max-width: 768px) {
  .dilog-box-loading {
    min-height: calc( 960px / 3 * 2 );
  }
  .poster {
    width: calc( 540px / 3 * 2 );
    height: calc( 960px / 3 * 2 );
    margin-bottom: 10px;
  }
  .poster-text {
    top: 36%;
  }
  .poster-text .text-1 {
    font-size: 14px;
  }
  .poster-text .text-2 {
    font-size: 22px;
  }
  .poster-text .text-2 div span{
    font-size: 16px;
  }
  .poster-text .text-3 {
    font-size: 38px;
  }
  .poster-text .text-3 span {
    font-size: 18px;
  }
  .poster-text-s {
    top: 63.5%;
  }
  .poster-text-s div {
    font-family: CustomFont4;
    font-size: 25px;
  }
  .poster-text-s div span {
    font-size: 16px;
  }
  .poster-text-center_s {
    top: 53.1%;
    font-size: 12px;
  }
  .poster-text-center_s span {
    margin-right: 6px;
  }
  .poster-text-left, .poster-text-right {
    font-size: 13px;
    line-height: 18px;
  }
  .poster-text-left div:first-child,.poster-text-right div:first-child {
    line-height: 20px;
    font-size: 14px;
  }
  .poster-text-left div:last-child,.poster-text-right div:last-child {
    font-size: 13px;
    line-height: 23px;
  }
  .poster-text-left span, .poster-text-right span{
    font-size: 7px;
  }
  .poster-text-left div:first-child span,.poster-text-right div:first-child span {
    font-size: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/posterS.vue